import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_QBE = _resolveComponent("QBE")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "label",
                class: "kn-material-input",
                type: "text",
                maxLength: "40",
                modelValue: _ctx.v$.dataset.sourceDatasetLabel.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.sourceDatasetLabel.$model = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.sourceDataset')) + " * ", 1)
            ])
          ])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            label: _ctx.$t('managers.datasetManagement.viewSQLButton'),
            class: "p-col-2 p-mr-2 p-button kn-button--primary",
            style: {"max-height":"38px"},
            onClick: _ctx.openQbeQueryDialog
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.$t('managers.datasetManagement.openQbeButton'),
            class: "p-col-2 p-button kn-button--primary",
            disabled: _ctx.parentValid,
            onClick: _ctx.openDatasetInQBE
          }, null, 8, ["label", "disabled", "onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      class: "dmdialog",
      visible: _ctx.qbeQueryDialogVisible,
      modal: true,
      closable: false,
      style: _ctx.qbeDescriptor.style.codeMirror
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
          start: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.viewSQLButton')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.qbeQueryDialogVisible = false))
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VCodeMirror, {
          class: "kn-height-full",
          ref: "codeMirror",
          value: _ctx.qbeQuery,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.qbeQuery = $event)),
          options: _ctx.codemirrorOptions
        }, null, 8, ["value", "options"])
      ]),
      _: 1
    }, 8, ["visible", "style"]),
    (_ctx.qbeVisible)
      ? (_openBlock(), _createBlock(_component_QBE, {
          key: 0,
          visible: _ctx.qbeVisible,
          dataset: _ctx.qbeDataset,
          "get-query-from-dataset-prop": _ctx.getQueryFromDataset,
          "source-dataset": _ctx.selectedDataset,
          "return-query-mode": false,
          onQuerySaved: _ctx.onQbeDialogSave,
          onClose: _ctx.onQbeDialogClose
        }, null, 8, ["visible", "dataset", "get-query-from-dataset-prop", "source-dataset", "onQuerySaved", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}